import { HttpContext, HttpContextToken } from "@angular/common/http";

export const BYPASS_ERROR = new HttpContextToken<boolean>(() => false);

export function byPassError() {
    return new HttpContext().set(BYPASS_ERROR, true);
}
